// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TvmB","title":"styles_title__2BS3W"};